(function () {

  if (window.__CUSTOM_DROPDOWN_INIT__) return;
  window.__CUSTOM_DROPDOWN_INIT__ = true;

  /* =================================
     CLOSE ALL DROPDOWNS
  ================================= */
  function closeAllDropdowns(except = null) {
    document
      .querySelectorAll('.custom-dropdown.open')
      .forEach(dropdown => {
        if (dropdown !== except) {
          dropdown.classList.remove('open');
        }
      });
  }

  /* =================================
     INIT DROPDOWNS
  ================================= */
  function initDropdowns() {
    const dropdowns = document.querySelectorAll('.custom-dropdown');
    if (!dropdowns.length) return;

    dropdowns.forEach(dropdown => {
      if (dropdown.__bound) return;
      dropdown.__bound = true;

      const selected = dropdown.querySelector('.dropdown-selected');
      const selectedText = dropdown.querySelector('.selected-text');
      const list = dropdown.querySelector('.dropdown-list');

      if (!selected || !list) return;

      /* OPEN / TOGGLE */
      selected.addEventListener('click', function (e) {
        e.stopPropagation();

        const isOpen = dropdown.classList.contains('open');

        // close all others
        closeAllDropdowns(dropdown);

        // toggle current
        dropdown.classList.toggle('open', !isOpen);
      });

      /* ITEM SELECT */
      list.addEventListener('click', function (e) {
        const item = e.target.closest('li');
        if (!item) return;

        e.stopPropagation();

        const value = item.getAttribute('data-value');
        const text = item.textContent.trim();

        selected.setAttribute('data-value', value);
        if (selectedText) selectedText.textContent = text;

        list.querySelectorAll('li').forEach(i => i.classList.remove('active'));
        item.classList.add('active');

        dropdown.classList.remove('open');
      });
    });

    /* CLICK OUTSIDE */
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.custom-dropdown')) {
        closeAllDropdowns();
      }
    });
  }

  /* =================================
     DOM READY
  ================================= */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDropdowns);
  } else {
    initDropdowns();
  }

})();